// extracted by mini-css-extract-plugin
export var addAttachmentButton = "SubmitTicketPage-module__addAttachmentButton___6B4+9";
export var addTagInput = "SubmitTicketPage-module__addTagInput___xffjj";
export var attachmentField = "SubmitTicketPage-module__attachmentField___md0un";
export var attachmentRow = "SubmitTicketPage-module__attachmentRow___zy6Nb";
export var cancelButton = "SubmitTicketPage-module__cancelButton___KnvJc";
export var charCount = "SubmitTicketPage-module__charCount___gsKYT";
export var charCountWarning = "SubmitTicketPage-module__charCountWarning___5ezdC";
export var closeButton = "SubmitTicketPage-module__closeButton___gHRPT";
export var errorMessage = "SubmitTicketPage-module__errorMessage___45c8S";
export var formGroup = "SubmitTicketPage-module__formGroup___XRgy5";
export var formGroupHalf = "SubmitTicketPage-module__formGroupHalf___ngtDR";
export var formGroupNarrow = "SubmitTicketPage-module__formGroupNarrow___oVPzb";
export var formInput = "SubmitTicketPage-module__formInput___bszKE";
export var formLabel = "SubmitTicketPage-module__formLabel___PEc+E";
export var formRow = "SubmitTicketPage-module__formRow___JI8Sk";
export var formSelect = "SubmitTicketPage-module__formSelect___NebES";
export var formTextarea = "SubmitTicketPage-module__formTextarea___v-ASD";
export var headerTeamSelect = "SubmitTicketPage-module__headerTeamSelect___tqHdF";
export var modalBody = "SubmitTicketPage-module__modalBody___Ul2pp";
export var modalFooter = "SubmitTicketPage-module__modalFooter___m9ajP";
export var modalHeader = "SubmitTicketPage-module__modalHeader___E80+A";
export var modalHeaderTitle = "SubmitTicketPage-module__modalHeaderTitle___lAEdA";
export var removeButton = "SubmitTicketPage-module__removeButton___+2zge";
export var requiredMark = "SubmitTicketPage-module__requiredMark___PJSZf";
export var richTextEditor = "SubmitTicketPage-module__richTextEditor___GJ0Vk";
export var submitButton = "SubmitTicketPage-module__submitButton___cuEiw";
export var submitPageActions = "SubmitTicketPage-module__submitPageActions___7p9Jl";
export var submitPageCard = "SubmitTicketPage-module__submitPageCard___E7SjX";
export var submitPageHeader = "SubmitTicketPage-module__submitPageHeader___aSVt6";
export var submitPageLayout = "SubmitTicketPage-module__submitPageLayout___6Xszm";
export var submitPageTitle = "SubmitTicketPage-module__submitPageTitle___Tef7F";
export var submitPageTitleRow = "SubmitTicketPage-module__submitPageTitleRow___3T8Sx";
export var tag = "SubmitTicketPage-module__tag___5cwXp";
export var tagRemove = "SubmitTicketPage-module__tagRemove___w8Pvf";
export var tagsList = "SubmitTicketPage-module__tagsList___mlPUd";